
  import { Vue, Component, Prop } from "vue-property-decorator";
  import Logo from "@/components/icons/jobBlissLogo.vue";

  @Component({
    components: {
    Logo
    }
  })
  export default class AuthCard extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: undefined }) readonly width?: string;
    @Prop({ type: Boolean, default: false }) readonly hideCard!: boolean;
    @Prop({ type: Boolean, default: false }) readonly skipCapitalization!: boolean;

    get cardClass(): String {
      switch (this.width) {
        case "wide":
          return "sm:max-w-2xl";
        default:
          return "sm:max-w-md";
      }
    }
  }
